import type { ReactNode } from "react";

import { skipToken } from "@reduxjs/toolkit/query";

import { DexibitI18nProvider } from "@dexibit/core";

import { useDecodedToken } from "../hooks/useUserData";
import { useGetUserQuery } from "../store/services/user";

interface AppI18nProviderProps {
  children: ReactNode;
}

// @dexibit/core components resolve their strings through an i18next context;
// without this provider they render raw catalog keys (e.g. ShareDialog).
// Locale comes from the signed-in user's profile; until it loads the provider
// falls back to the browser locale.
export const AppI18nProvider = ({ children }: AppI18nProviderProps) => {
  const decodedToken = useDecodedToken();
  const userId = decodedToken?.sub;

  const { data: user } = useGetUserQuery(
    userId !== undefined ? { id: +userId } : skipToken,
  );

  return (
    <DexibitI18nProvider locale={user?.properties?.locale}>
      {children}
    </DexibitI18nProvider>
  );
};
